<div class="ds-callout">
  <app-ds-rounded-icon [icon]="customIcon || iconList[variant]" size="medium" [variant]="variant"></app-ds-rounded-icon>
  <div class="ds-callout-content">
    <p class="ds-heading-2 ds-color-core-neutral-10" *ngIf="title" [innerHTML]="title"></p>
    <p class="ds-running-2 ds-color-core-neutral-7" *ngIf="description" [innerHTML]="description"></p>
    <div class="ds-callout-links">
      <ng-content select="[actions]"></ng-content>
    </div>
  </div>
</div>
